import restCrudActions from '../../../../np-crud/store/restCrudActions';
import { getAxiosInstance } from '../../../../np-rest/rest';
import { snackActions } from '../../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'project',
    pluginName: 'PROJECT',
    entityName: 'PROJECT',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
    createFailedUseBackendMessage: true,
    createSuccessUseBackendMessage: true,
    deleteFailedUseBackendMessage: true,
    editFailedUseBackendMessage: true,
    bulkDeleteFailedUseBackendMessage: true
});

// Fetch Project action creators
export const fetchProjectInit = () => { return crudActions.fetchInit(); }
export const fetchProjectStart = () => { return crudActions.fetchStart(); }
export const fetchProjectSuccess = () => { return crudActions.fetchSuccess(); }
export const fetchProjectFail = () => { return crudActions.fetchFail(); }

export const fetchProjectsCount = (filterData, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchProjectStart());
        try {
            let countRes = await rest.post("project/count", filterData, { cancelToken: options.countSource.token });
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchProjectSuccess(0, []));
                }
                return { data: countRes.data.result.data }
            }
            if (countRes && countRes.canceled) {
                return { data: 0, canceled: true };
            }
            dispatch(fetchProjectFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch projects."}`,
                options: {
                    variant: 'warning'
                }
            });
            return { data: 0 };
        } catch (error) {
            dispatch(fetchProjectFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch projects."}`,
                options: {
                    variant: 'error'
                }
            });
            return { data: 0 };
        }
    }
};


export const fetchProjects = (filterData, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchProjectStart());
        try {
            let listRes = await rest.post("project/list", filterData, { cancelToken: options.listSource.token });
            if (listRes && listRes.canceled) {
                return { data: [], canceled: true };
            }
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchProjectSuccess(filterData.count, listRes.data.result.data));
                return { data: listRes.data.result.data };
            }
            dispatch(fetchProjectFail());
            return { data: [] };
        }
        catch (error) {
            dispatch(fetchProjectFail());

            return { data: [] };
        }
    }
};


// Create Project  action creators
export const createProjectInit = () => { return crudActions.createInit(); };
export const createProjectStart = () => { return crudActions.createStart(); };
export const createProjectSuccess = createdProject => { return crudActions.createSuccess(createdProject); };
export const createProjectFail = error => { return crudActions.createFail(error); };
export const createProject = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createProjectStart());
        try {
            let res = await rest.post('/project/create', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully created project.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createProjectFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create project."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create project."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createProjectFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Delete Project  action creators
export const bulkDeleteProjectInit = () => { return crudActions.bulkDeleteInit(); };
export const bulkDeleteProjectStart = () => { return crudActions.bulkDeleteStart(); };
export const bulkDeleteProjectSuccess = bulkDeleted => { return crudActions.bulkDeleteSuccess(bulkDeleted); };
export const bulkDeleteProjectFail = error => { return crudActions.bulkDeleteFail(error); };
export const bulkDeleteProject = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteProjectStart());
        try {
            let res = await rest.post('/project/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteProjectSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted projects.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteProjectFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete projects."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete projects."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteProjectFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Edit project  action creators
export const editProjectInit = () => { return crudActions.editInit(); };
export const editProjectStart = () => { return crudActions.editStart(); };
export const editProjectSuccess = editedProject => { return crudActions.editSuccess(editedProject); };
export const editProjectFail = error => { return crudActions.editFail(error); };

export const editProject = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editProjectStart());
        try {
            let res = await rest.post('/project/save', params);
            if (res.data && res.data.succeeded) {
                // dispatch(editProjectSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully updated project.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editProjectFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit project."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit project."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editProjectFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Load project action creators
export const loadProjectInit = () => { return crudActions.loadInit(); };
export const loadProjectStart = () => { return crudActions.loadStart(); };
export const loadProjectSuccess = loadedProject => { return crudActions.loadSuccess(loadedProject); };
export const loadProjectFail = error => { return crudActions.loadFail(error); };
export const loadProject = (loadParams, options = {}) => {
    return async dispatch => {
        await crudActions.load(dispatch, loadParams, options);
    };
};


export const fetchOperatingSystems = (params, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/operating_systems/list', { listAll: true, ...params }, { cancelToken: options?.cancelToken?.token });
            if (res && res.canceled) {
                return [];
            }
            if (res.data && res.data.succeeded) {
                const operatingSystems = [];
                for (var os of res.data.result.data) {
                    operatingSystems.push({ value: os.OperatingSystemID, displayValue: `${os.Name}` });
                }
                return operatingSystems;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
}

export const updatePresets = (params, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/project/update-presets', params, { cancelToken: options?.cancelToken?.token });
            if (res && res.canceled) {
                return [];
            }
            if (res.data && res.data.succeeded) {
                return { status: true };
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })
                return { status: false };
            }

        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return { status: false };
        }
    };
}


export const fetchErasureMethod = (params) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/customer-erasure-method/list', { listAll: true, formatForWEBUI: true, q: { Visible: [1] }, ...params });
            if (res.data && res.data.succeeded) {
                return res.data.result.data;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot fetch securaze standards."}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            return [];
        }
    };
}


export const fetchGrades = (id) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/grades/list', { listAll: true, ...id });
            if (res.data && res.data.succeeded) {
                const grades = [];
                for (var grade of res.data.result.data) {
                    grades.push({ value: grade.GradeID, displayValue: `${grade.InternationalGrading} (${grade.Condition})` });
                }
                return grades;
            }
            return [];
        } catch (error) {
            return [];
        }
    };
}

export const fetchPrinters = (id) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/printers/list', { listAll: true, ...id });
            if (res.data && res.data.succeeded) {
                const printers = [];
                for (var printer of res.data.result.data) {
                    printers.push({ value: printer.PrinterID, displayValue: `${printer.Name} (${printer.PrinterType} / ${printer.ConnectionType})` });
                }
                return printers;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot fetch printers."}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            return [];
        }
    };
}

export const fetchOrders = (id) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('palettes/order/list', { ...id, listAll: true, formatForWEBUI: true, productChangePalette: true });
            let response = res && res.data && res.data.result && res.data.result.data ? res.data.result.data : false;
            return response ? response : [];
        } catch (error) {
            return [];
        }
    }
}

export const fetchCollies = (id) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('colli/list', { listAll: true, formatForWEBUI: true, ...id, productChangePalette: true });
            let response = res && res.data && res.data.result && res.data.result.data ? res.data.result.data : false;

            return response ? response : [];
        } catch (error) {
            return [];
        }
    }
}